import axios from 'axios'
import { ExpenseFields } from 'src/components/ExpenseForm/ExpenseForm'
import {
  ExpenseReportResponse,
  ExpenseResponse,
} from 'src/models/expenseReport.model'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Create a single out-of-pocket expense (POST /expenses). Errors are normalized by `getResponseData` — callers never touch a raw `err.response`.
 */
export const createExpense = async (
  body: ExpenseFields,
): Promise<ExpenseResponse> => {
  return getResponseData(
    axios.post<ExpenseResponse>(
      `/expenses`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

/**
 * Approve a set of expenses (POST /expenses/approve). Returns the full updated parent expense report.
 */
export const approveExpenses = async (
  expenseIds: string[],
): Promise<ExpenseReportResponse> => {
  return getResponseData(
    axios.post<ExpenseReportResponse>(
      `/expenses/approve`,
      { expenses: expenseIds },
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

/**
 * Delete a set of expenses (DELETE /expenses with a request body). Returns the full updated parent expense report.
 */
export const deleteExpenses = async (
  expenseIds: string[],
): Promise<ExpenseReportResponse> => {
  return getResponseData(
    axios.delete<ExpenseReportResponse>(`/expenses`, {
      ...getRequestConfig(RequestConfig.Default),
      data: { expenses: expenseIds },
    }),
  )
}
